<button
  class="bypass-block-button skip-to-main-content focus-link"
  tabindex="1"
  (click)="focusOnElement('.router-outlet-container')">
  {{ 'wl.westpac.bypass_block.skip_to_main_content' | translate }}
</button>
<button
  class="bypass-block-button skip-to-navigation focus-link"
  tabindex="1"
  (click)="focusOnElement('rd-core-main-header-wrapper')">
  {{ 'wl.westpac.bypass_block.skip_to_navigation' | translate }}
</button>
